import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { IGaussResponse } from "../../../dto/converters/IGaussResponse";
import { TranslatorService } from "../../../services/translator-service";
import GaussGlobalLocationsSelect from "../form-components/GaussGlobalLocationsSelect";
import {useTranslation} from 'react-i18next';

const GaussGlobalSingle = () => {
    
    const [gaussLocalFormInputData, setGaussLocalFormInputData] = useState({ x: "", y: "", h: "", sourceFormat: "1",  resultFormat: "1"});
    const [gaussLocationData, setGaussLocationData] = useState({ sourceFormat: "1",  resultFormat: "1", inputData: [] as IGaussResponse[]});
    const [resultFromApi, setResultFromApi] = useState(null as IGaussResponse | null);
    const {t} = useTranslation();

    const queryToApi = async (params: {x: string, y: string, h: string, sourceFormat: string, resultFormat: string}) => {
        params.sourceFormat = gaussLocationData.sourceFormat;
        params.resultFormat = gaussLocationData.resultFormat;

        let result = await TranslatorService.queryApiGet<IGaussResponse>(
            "/gauss",
            params
        );
        setResultFromApi(result.data!);
    }

    function hasNotValidValues() {
        if (gaussLocalFormInputData.x === "" || gaussLocalFormInputData.y === "") {
            return true;
        }
        
        return isNaN(Number(gaussLocalFormInputData.x)) || isNaN(Number(gaussLocalFormInputData.y));
    }

    return (
        <>
            <Form.Group className="mb-3">
            <Row>
                    <Col>
                        <GaussGlobalLocationsSelect setFormData={setGaussLocationData} formData={gaussLocationData} isSource={true} />
                    </Col>
                    <Col>
                        <GaussGlobalLocationsSelect setFormData={setGaussLocationData} formData={gaussLocationData} isSource={false} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {gaussLocationData.sourceFormat === "10" ? <>x<sub>L-EST97</sub></> : <>x</>}<Form.Control onChange={e => setGaussLocalFormInputData({ ...gaussLocalFormInputData, x: e.target.value })} type="text" size="sm" name="x" />
                    </Col>
                    <Col>
                        {gaussLocationData.sourceFormat === "10" ? <>y<sub>L-EST97</sub></> : <>y</>}<Form.Control onChange={e => setGaussLocalFormInputData({ ...gaussLocalFormInputData, y: e.target.value })} type="text" size="sm" name="y" />
                    </Col>
                    <Col>
                        H: <Form.Control onChange={e => setGaussLocalFormInputData({ ...gaussLocalFormInputData, h: e.target.value })} type="text" size="sm" name="h" />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            onClick={(e) => {e.preventDefault(); queryToApi(gaussLocalFormInputData);}}
                            type="submit" 
                            disabled={hasNotValidValues()}
                        >
                            {t('calculateButtonLabel')}
                        </Button>
                    </Col>
                </Row>
            </Form.Group>
            {resultFromApi != null && <>{t('answer')}: <b>x</b> = {(gaussLocalFormInputData.resultFormat === "8") ? resultFromApi.x.toFixed(8) : resultFromApi.x} <b>y</b> = {(gaussLocalFormInputData.resultFormat === "8") ? resultFromApi.y.toFixed(8) : resultFromApi.y} </>}
            <br /><br /><br />
        </> 
    );

}

export default GaussGlobalSingle;

